module.exports = __webpack_public_path__ + "static/img/voice.ffcb9dd4.svg";